import React from 'react'

import { CTALink, HeadingMedium, HeadingXSmall, Label, StatusText } from '@pb/components'
import { useSelector } from 'react-redux'

import { ACCOUNT_ROUTES } from 'App/constants'
import appSelectors from 'App/duck/selectors'
import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'
import useTrackAccountClickEvent from 'features/account/hooks/useTrackAccountClickEvent'

import cardSelectors from '../../duck/selectors'
import styles from './CardBackTitle.scss'
import Props from './types'

const CardBackTitle: React.FC<Props> = ({ name, email }) => {
  const currentTierCopy = useSelector(cardSelectors.getCurrentTierCopy)
  const isPayLaterAllowed = useSelector(appSelectors.getIsPayLaterActivationAllowed)
  const isPayLaterActivated = useSelector(appSelectors.getIsPayLaterActivatedForUser)
  const trackPDFClick = useTrackAccountClickEvent()
  const trackPayLaterCTA = trackPDFClick(ACCOUNT_TRACKING_EVENTS.onPayLaterActivationCardClick)

  return (
    <>
      <HeadingXSmall Tag="p" className={styles.userInfo}>
        {currentTierCopy}
      </HeadingXSmall>
      <HeadingMedium className={styles.userDisplayName}>{name || email}</HeadingMedium>
      {isPayLaterAllowed &&
        (isPayLaterActivated ? (
          <StatusText type="activated" icon className={styles.userInfo}>
            <Label className={styles.statusText} copyKey="pay.later.active" />
          </StatusText>
        ) : (
          <CTALink
            inline
            href={ACCOUNT_ROUTES.PayLaterStoreActivationInfo.path}
            className={styles.activateLink}
            onClick={() => trackPayLaterCTA()}
          >
            <Label className={styles.statusText} copyKey="mysettings.paylater.activate.link" />
          </CTALink>
        ))}
    </>
  )
}

export default CardBackTitle
